function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBedroom = function SvgBedroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.7,
    height: 14.033
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1990"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.88 106.278v-1.667a1.09 1.09 0 0 1 1.067-1.111h4.267a1.09 1.09 0 0 1 1.067 1.111v1.667",
    "data-name": "Shape 47",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-471.93 -99.817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.52 106.278v-1.667a1.09 1.09 0 0 1 1.067-1.111h4.267a1.09 1.09 0 0 1 1.067 1.111v1.667",
    "data-name": "Shape 48",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-474.17 -99.817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.142 107.25H486.3a1.453 1.453 0 0 1 1.422 1.481v3.519h-16v-3.519a1.453 1.453 0 0 1 1.42-1.481",
    "data-name": "Shape 49",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-471.37 -100.789)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.72 114v2.222",
    "data-name": "Shape 50",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-471.37 -102.539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.32 114v2.222",
    "data-name": "Shape 51",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-476.97 -102.539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.68 105.111v-5A1.09 1.09 0 0 0 485.613 99h-10.666a1.09 1.09 0 0 0-1.067 1.111v5",
    "data-name": "Shape 52",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".7px"
    },
    transform: "translate(-471.93 -98.65)"
  })));
};
export { SvgBedroom as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi43IiBoZWlnaHQ9IjE0LjAzMyIgdmlld0JveD0iMCAwIDE2LjcgMTQuMDMzIj4KICAgIDxnIGRhdGEtbmFtZT0iR3JvdXAgMTk5MCI+CiAgICAgICAgPHBhdGggZGF0YS1uYW1lPSJTaGFwZSA0NyIgZD0iTTQ3My44OCAxMDYuMjc4di0xLjY2N2ExLjA5IDEuMDkgMCAwIDEgMS4wNjctMS4xMTFoNC4yNjdhMS4wOSAxLjA5IDAgMCAxIDEuMDY3IDEuMTExdjEuNjY3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDcxLjkzIC05OS44MTcpIiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTojMzMzO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6LjdweCIvPgogICAgICAgIDxwYXRoIGRhdGEtbmFtZT0iU2hhcGUgNDgiIGQ9Ik00ODIuNTIgMTA2LjI3OHYtMS42NjdhMS4wOSAxLjA5IDAgMCAxIDEuMDY3LTEuMTExaDQuMjY3YTEuMDkgMS4wOSAwIDAgMSAxLjA2NyAxLjExMXYxLjY2NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ3NC4xNyAtOTkuODE3KSIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6IzMzMztzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOi43cHgiLz4KICAgICAgICA8cGF0aCBkYXRhLW5hbWU9IlNoYXBlIDQ5IiBkPSJNNDczLjE0MiAxMDcuMjVINDg2LjNhMS40NTMgMS40NTMgMCAwIDEgMS40MjIgMS40ODF2My41MTloLTE2di0zLjUxOWExLjQ1MyAxLjQ1MyAwIDAgMSAxLjQyLTEuNDgxeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ3MS4zNyAtMTAwLjc4OSkiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlOiMzMzM7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDouN3B4Ii8+CiAgICAgICAgPHBhdGggZGF0YS1uYW1lPSJTaGFwZSA1MCIgZD0iTTQ3MS43MiAxMTR2Mi4yMjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00NzEuMzcgLTEwMi41MzkpIiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTojMzMzO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6LjdweCIvPgogICAgICAgIDxwYXRoIGRhdGEtbmFtZT0iU2hhcGUgNTEiIGQ9Ik00OTMuMzIgMTE0djIuMjIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDc2Ljk3IC0xMDIuNTM5KSIgc3R5bGU9ImZpbGw6bm9uZTtzdHJva2U6IzMzMztzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOi43cHgiLz4KICAgICAgICA8cGF0aCBkYXRhLW5hbWU9IlNoYXBlIDUyIiBkPSJNNDg2LjY4IDEwNS4xMTF2LTVBMS4wOSAxLjA5IDAgMCAwIDQ4NS42MTMgOTloLTEwLjY2NmExLjA5IDEuMDkgMCAwIDAtMS4wNjcgMS4xMTF2NSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ3MS45MyAtOTguNjUpIiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZTojMzMzO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6LjdweCIvPgogICAgPC9nPgo8L3N2Zz4K";